export const PASSWORD_VALIDATION_REGEX = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';

export const DEFAULT_LOCALE = 'en-US';

export const DEFAULT_DIGITS_INFO = '1.0-2';
